export function findStation(state) {
  // eslint-disable-next-line camelcase
  return (local_id) => state.all.find(((v) => v.local_id === local_id));
}
